'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbDateFormatter = fbDateFormatter;

var _dateTimeHelper = require('./dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fbDateFormatter() {
    'ngInject';

    return {
        restrict: 'A',
        require: ['ngModel', '?^fbDateTimePicker'],
        link: function link(scope, element, attribute, controllers) {
            var ngModel = controllers[0];
            var datetimepicker = controllers[1];

            var dateTimeHelper = new _dateTimeHelper2.default(attribute.format || _dateTimeHelper2.default.defaultDateFormat);

            ngModel.$parsers.push(function (val) {
                return dateTimeHelper.parseValue(val);
            });
            ngModel.$formatters.push(function (val) {
                return dateTimeHelper.formatValue(val);
            });

            if (datetimepicker) {
                datetimepicker.format = dateTimeHelper.momentFormat;
                // Is this necessary?
                //scope.$watch(ngModel.$modelValue, (newValue /*, oldValue*/) => {
                //    datetimepicker.datetime = newValue;
                //});
                datetimepicker.onValueChanged = function (e) {
                    if (e.date) {
                        ngModel.$setViewValue(e.date.format(dateTimeHelper.momentFormat));
                    } else {
                        ngModel.$setViewValue();
                    }
                };
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/datepicker/dateFormatter.directive.js
// module id = 707
// module chunks = 0